window.verifyByApp = function(email, password,callBackName){
    const request = config.jsBridge.login + "?email=" + email + "&password=" + password + "&cb=" + callBackName;
    const response = window.prompt(request, "");
}

window.loginByApp = function(email, callBackName){
    const request = config.jsBridge.login + "?email=" + email + "&cb=" + callBackName;
    const response = window.prompt(request, "");
}

window.getAccountInfo = function(callBackName){
    const request = config.jsBridge.getAccountInfo + "?cb=" + callBackName;
    const response = window.prompt(request, "");
}

window.getStorefrontToken = function(callBackName){
    const request = config.jsBridge.getShopifyToken + "?cb=" + callBackName;
    const response = window.prompt(request, "");
}

window.closePage = function(){
    const request = config.jsBridge.closeWebView + "?cb=closePageCallback";
    const response = window.prompt(request, "");
}

window.closePageCallback = function(url, data){

}

window.setContent2App = function(key, value){
    const request = config.jsBridge.setKeyValue + '?domain=shopify&key=' + key + '&value=' + value;
    const response = window.prompt(request, "");
}

window.getContentFromApp = function(key, callBackName){
    const request = config.jsBridge.getKeyValue + "?domain=shopify&key=" + key + "&cb=" + callBackName;
    const response = window.prompt(request, "");
}

window.toast = function(text, callbackName){
    let request = config.jsBridge.toast + "?text=" + text;
    if(callbackName){
        request += "&cb=" + callbackName;
    }
    const response = window.prompt(request, "");
}

window.writeLog = function(tag, msg, callbackName){
    let ua = navigator.userAgent;
    if(ua.indexOf("GlazeroWebView")>=0){
       let request = config.jsBridge.writeLog + "?tag=" + tag + "&msg=" + msg;
       if(callbackName){
          request += "&cb=" + callbackName;
       }
       const response = window.prompt(request, "");
    }else{
       console.log(msg) ;
    }
}

window.hiddenLoading = function(callbackName){
    let request = config.jsBridge.hiddenLoading;
    if(callbackName){
        request += "?cb=" + callbackName;
    }
    const response = window.prompt(request, "");
}

window.gzOnClickEvent = function(eventId, callBackName){
    if(eventId == "titleBarAccount"){
        document.getElementById("loginNav").click();
    }else if(eventId == "titleBarShoppingCart"){
        document.getElementById("cartNav").click();
    }
}

window.gzQueryData = function(key, callBackName){
    if(key == "shoppingCartCount"){
        const param = {"seq": [{"name":"StorefrontToken", "required": true, "errMsg": "获取StorefrontToken失败"},
                            {"name":"GetAccessToken", "required": false, "errMsg": "获取AccessToken失败"},
                            {"name":"GetAccountInfo", "required": false, "errMsg": "获取AccountInfo失败"},
                            {"name":"GetCartId", "required": false, "errMsg": "获取CartId失败"},
                            {"name":"GetCart", "required": false, "errMsg": "获取Cart失败"}
                            ], "successCallback": envSeqLoaded};
        loadEnvSeq(param);
    }
}

window.setTitleText = function(text, callBackName){
    const request = config.jsBridge.setTitleText + "?text=" + text;
    if(callBackName){
        request += "&cb=" + callBackName;
    }
    const response = window.prompt(request, "");
}

window.setTitleStyle = function(text, callBackName){
    const request = config.jsBridge.setTitleStyle + "?pageBgColor=" + text;
    if(callBackName){
        request += "&cb=" + callBackName;
    }
    const response = window.prompt(request, "");
}

window.reportevent = function(text, attrs, callBackName){
    const request = config.jsBridge.reportevent + "?id=" + text+"&attrs="+attrs;
    if(callBackName){
        request += "&cb=" + callBackName;
    }
    const response = window.prompt(request, "");
}

window.openH5url = function(url, hidetitlebar,titleText,titleBgColor,closepage,useSystemBrowser,callBackName){
    if(isNewVerion()){
      const request = config.jsBridge.openH5url + "?uri="+url+"&hidetitlebar="+hidetitlebar+"&titleText="+titleText+"&pageBgColor="+titleBgColor+"&closepage="+closepage+"&useSystemBrowser="+useSystemBrowser;
      if(callBackName){
          request += "&cb=" + callBackName;
      }
      const response = window.prompt(request, "");
    }else{
      let decodedURI = decodeURIComponent(url);
      window.location.href = decodedURI;
    }    
}

window.getHeaders = function(callBackName){
    const request = config.jsBridge.getheaders+"?cb=" + callBackName;
    const response = window.prompt(request, "");
}

window.getEnv = function(callBackName){
    const request = config.jsBridge.getdev+"?cb=" + callBackName;
    const response = window.prompt(request, "");
}





